<template>
  <div id="supplier-user-list">
    <div class="md-layout">
      <div class="md-layout-item md-size-80">
        <h6>Users</h6>
      </div>
      <div class="md-layout-item md-size-20 text-right">
        <md-button
          v-if="$allowed('supplier.manage')"
          class="md-icon-button md-dense md-primary md-simple"
          @click="showDialog"
        >
          <md-icon>add</md-icon>
          <md-tooltip md-direction="top"
            >Assign a User to this Partner</md-tooltip
          >
        </md-button>
      </div>
    </div>

    <template v-if="workers">
      <div class="md=layout">
        <div class="md-layout-item md-size-100">
          <md-table>
            <md-table-row v-for="worker in workers" :key="worker.id">
              <md-table-cell>{{ worker.full_name }}</md-table-cell>
              <md-table-cell class="text-right">
                <md-button
                  v-if="$allowed('supplier.manage')"
                  class="md-just-icon md-simple md-danger "
                  @click="removeWorker(worker.id)"
                >
                  <md-icon>delete</md-icon>
                  <md-tooltip md-direction="top">Remove User</md-tooltip>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>
    </template>

    <md-dialog
      :md-active.sync="showAddUserDialog"
      id="add-user-dialog"
      class="single-choice-dialog"
    >
      <md-dialog-title>Assign a User</md-dialog-title>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addWorker)">
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <customer-dropdown v-model="userId" />
            </div>
          </div>

          <md-dialog-actions>
            <md-button
              class="md-primary md-dense"
              @click="showAddUserDialog = false"
              >Cancel</md-button
            >
            <md-button type="submit" class="md-primary md-dense">Add</md-button>
          </md-dialog-actions>
        </form>
      </ValidationObserver>
    </md-dialog>
  </div>
</template>

<script>
import CustomerDropdown from "@/components/Handi/Users/CustomerDropdown.vue";

export default {
  props: ["workers"],
  emits: ["addWorker", "removeWorker"],

  data() {
    return {
      showAddUserDialog: false,
      userId: null
    };
  },

  components: {
    CustomerDropdown
  },

  computed: {},

  methods: {
    removeWorker(workerId) {
      this.$emit("removeWorker", workerId);
    },
    addWorker() {
      this.showAddUserDialog = false;
      this.$emit("addWorker", this.userId);
    },
    showDialog() {
      this.showAddUserDialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";
#supplier-user-list {
  margin-top: 1rem;
  border-top: 2px solid $brand-primary;
  padding-top: 1rem;

  .md-table-cell {
    padding: 4px 4px 4px 0;
    height: 36px;
  }
  .worker-name {
    align-self: center;
  }

  .md-button.md-just-icon,
  .md-icon-button.md-dense {
    width: 21px;
    height: 21px;
    min-width: 21px;
  }

  h6,
  .h6 {
    margin: 0 0 0.5rem 0;
  }
}
</style>
